"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Typography_1 = require("../Typography/Typography");
function BreadcrumbText({ children }) {
    return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ variant: "h200", className: "ml-5 text-silver-90" }, { children: children })));
}
exports.BreadcrumbText = BreadcrumbText;
//# sourceMappingURL=BreadcrumbText.js.map